import React from "react";
import "../App.css";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faDownload } from "@fortawesome/free-solid-svg-icons";
function squareIcon(props) {
  // const downloadIcon = <FontAwesomeIcon icon={faDownload} />;
  const { val } = props;
  return (
    <div className="columns is-multiline">
      {val &&
        val.map((elem) => {
          return (
            <div className="column is-4" key={elem.name}>
              <article className="cardPadding card is-shady has-text-centered">
                <span>
                  {" "}
                  <b className="cardContentTitle">
                    {" "}
                    <a
                      href={elem.link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {elem.name}
                    </a>{" "}
                  </b>{" "}
                  <br />{" "}
                </span>{" "}
                <p style={{ margin: 0 }} className="cardContent">
                  {" "}
                  {elem.punchline}{" "}
                </p>
                <figure style={{ margin: "0" }}>
                  <a href={elem.link} target="_blank" rel="noopener noreferrer">
                    <img
                      src={elem.image}
                      alt={elem.punchline}
                      height={128}
                      width={128}
                    />
                  </a>
                </figure>
                <div className="cardButtonCustomStyle">
                  <div className="field">
                    <p className="control has-text-centered">
                      <a
                        href="mailto:reachus@codeops.tech"
                        className="linkdeco"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <button className="button is-info">
                          Request Quote
                        </button>
                      </a>
                    </p>
                    <>
                      {/* {elem.dataSheetLink ? (
                        <p className="control has-text-centered">
                          <a
                            href={elem.dataSheetLink}
                            className="linkdeco"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <button
                              disabled={!elem.dataSheetLink}
                              className="button is-info"
                            >
                              &nbsp;Datasheet &nbsp;&nbsp;
                              <span className="icon is-small">
                                {downloadIcon}
                              </span>
                              &nbsp;&nbsp;
                            </button>
                          </a>
                        </p>
                      ) : (
                        ""
                      )} */}
                    </>
                  </div>
                </div>
              </article>
            </div>
          );
        })}
    </div>
  );
}

export default squareIcon;
